import { useState } from 'react';
import useDebounce from '../../../hooks/useDebounce/useDebounce';
import { useGlobalSearchQuery } from '../../../services/modules/global-search/globalSearch.queries';
import { inputCodeWithoutZeroWidthSpace } from '../../../utils/regexes';

const DEBOUNCE_DELAY_MS = 300;
const MIN_QUERY_LENGTH = 3;

interface UseGlobalSearchParams {
  enabled: boolean;
  limit?: number;
}

const useGlobalSearch = ({ enabled, limit }: UseGlobalSearchParams) => {
  const [query, setQuery] = useState('');

  const rawDebouncedQuery = useDebounce(query, DEBOUNCE_DELAY_MS);
  const debouncedQuery = inputCodeWithoutZeroWidthSpace(rawDebouncedQuery);
  const isDebouncing = query !== rawDebouncedQuery;

  const hasReachedMinLength =
    query.length >= MIN_QUERY_LENGTH && debouncedQuery.length >= MIN_QUERY_LENGTH;
  const isQueryEnabled = enabled && hasReachedMinLength;

  const { data, isLoading, isFetching, isError, error, refetch } = useGlobalSearchQuery(
    { q: debouncedQuery, limit },
    { enabled: isQueryEnabled },
  );

  return {
    query,
    setQuery,
    debouncedQuery,
    isDebouncing,
    hasReachedMinLength,
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
};

export default useGlobalSearch;
